module.exports = __webpack_public_path__ + "assets/7e4e23f4c1e12d1fc298af2dfddcf651.png";